import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, Output, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { VisDialogComponent } from '../components/dialog/vis-dialog/vis-dialog.component';
import { DateHelper } from '../helpers/date-helper';
import { UserConfirmService } from 'src/app/services/user-confirm.service';
import { EasyFormService } from 'src/app/services/easy-form-service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { CheckDateRegionServiceService } from 'src/app/services/check-date-region-service.service';

/** 
 * 這個驅動是拿來掛在Button上，令其click的時候的檢查輸入的日期區間，並在使用者確認後繼續或阻擋
 * 
 * 如果是程式性呼叫查詢 請直接注入CheckDateRegionServiceService 並以Check(...)方法進行判斷
 * 用法：
 * 
 * <app-datepicker #sDate></app-datepicker>
 * 
 * <app-datepicker #sDate></app-datepicker>
 * 
 * [appCheckDateRegion]="[sDate.Value,sDate.Value]"
 * 
 * (guardedClick)="doSomething(...)"
 */
@Directive({
    selector: '[appCheckDateRegion]',
    exportAs: 'appCheckDateRegion'
})
export class CheckDateRegionDirective {
    @Input()
    appCheckDateRegion: Date[]
    @Input()
    waringOver = 30;
    @Input()
    confirmOver = 180;
    @Input()
    blockOver = 360;

    @Output() guardedClick = new EventEmitter<MouseEvent>();
    private locked = false;
    
    constructor(private checkDateRegionServiceService:CheckDateRegionServiceService) {}
    @HostListener('click', ['$event'])
    async onClick(e: MouseEvent) {
        e.preventDefault();
        e.stopImmediatePropagation(); // 一定先擋

        if (this.locked) return;
        this.locked = true;
        try {
            var sDate = new Date(this.appCheckDateRegion[0]);
            var eDate = new Date(this.appCheckDateRegion[1]);
            if(await this.checkDateRegionServiceService.Check(sDate,eDate,this.waringOver,this.confirmOver,this.blockOver)){
                this.guardedClick.emit(e)
            }
        } finally {
            this.locked = false;
        }
    }

}

